import { observer } from "mobx-react-lite";
import styled from "styled-components";
import { Button } from "antd-mobile";
import { QRCodeCanvas } from "qrcode.react";
import PageWrap from "../components/PageWrap";
import PageHeader, { headerHeight } from "../components/PageHeader";
import { copyTextToClipboard } from "../../utils/copy";
import { ToastSuccess } from "../../components/Toast";
import { useStores } from "../../models";

const shareBg = require("../../assets/images/wallet/share-bg.jpeg");
const logo = require("../../assets/images/app-intro-logo.png");

const ScrollArea = styled.div`
  height: calc(100% - ${headerHeight});
  overflow: auto;
  padding: 16px;
  background: #f7f8ff;
`;

const Poster = styled.div`
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  background: #fff;
`;

const Bg = styled.img`
  width: 100%;
  display: block;
`;

const Content = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 24px 16px 28px;
`;

const Share = () => {
  const { configStore } = useStores();
  const url =
    configStore.redirectURL || "https://official.magpiechat.com";

  return (
    <PageWrap>
      <PageHeader title="分享" />
      <ScrollArea>
        <Poster id="share-poster">
          <Bg src={shareBg} alt="" />
          <Content>
            <div style={{ textAlign: "center" }}>
              <img src={logo} alt="" width={64} height={64} />
              <div style={{ fontSize: 22, fontWeight: 700, marginTop: 8 }}>喜鹊币</div>
              <div style={{ color: "#666" }}>充值无痕 安全无忧</div>
            </div>
            <div style={{ background: "#fff", padding: 8, borderRadius: 8 }}>
              <QRCodeCanvas value={url} size={91} />
            </div>
          </Content>
        </Poster>
        <Button
          color="primary"
          block
          style={{ marginTop: 16 }}
          onClick={() => {
            copyTextToClipboard(url);
            ToastSuccess("链接已复制");
          }}
        >
          复制分享链接
        </Button>
      </ScrollArea>
    </PageWrap>
  );
};

export default observer(Share);
